import React from "react";
import "./testimonials.css";
import AVTR6 from "../../assets/astha.jpeg";
import AVTR1 from "../../assets/divyanshu.jpeg";
import AVTR2 from "../../assets/anshika.jpeg";
import AVTR3 from "../../assets/aman.jpeg";
import AVTR4 from "../../assets/yashasvika.jpeg";
import AVTR5 from "../../assets/atif.jpeg";

import { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import 'swiper/css/pagination';


import { FaLinkedin, } from 'react-icons/fa'

const peers = [

  {
    avatar: AVTR1,
    linkedin:'https://www.linkedin.com/in/divyanshu-singh-a411a1247',
    name: "Divyanshu Singh",
    review:"I met Desh Deepak kushwaha in my second semester he seemed to be a hardworking person, his inclination was towards web development day by day he worked on his skills and then we worked on a small game project.Now, he is developing more and more projects, hope for his better future!!Regards ",
  },
  {
    avatar: AVTR2,
    linkedin:'https://www.linkedin.com/in/anshika-baijal-0a8782233',
    name: "Anshika Baijal",
    review:
      "I really enjoyed working with Desh Deepak in developing a new website. My colleague cum friend was very quick to follow up and made a strong rapport throughout the process.Needless to say,I was delighted with the final result and by his hardwork.Looking forward for more collabs and opportunities to work together.",
  },
  {
    avatar: AVTR6,
    linkedin:'#',
    name: "Astha Mishra",
    review:
      "If u r searching for an excellent web designer then the best  recommendation in my list is Deshdeepak. He made my working way easier with his skills.His disciplined attitude and hard work finally pays off through this wonderful website.He keeps on improving his work everyday.. All the best to you .",
  },
  {
    avatar: AVTR3,
    linkedin:'https://www.linkedin.com/in/avicxd/',
    name: "Aman Verma",
    review:
      "I would highly recommend Everyone to work with Desh Deepak. He is great in his work . The traffic to my website has increased because of him only.",
  },
  {
    avatar: AVTR4,
    linkedin:'https://www.linkedin.com/in/yashasvika-saxena-769604213/',
    name: "Yashasvika Rujali Saxena",
    review:
      "I came to Desh Deepak when my friend recommended his name. He is an absolute Web Designer. Without much involvement of me, he gave an exceptional upshot. He is always committed to constant improvement and it shows.",
  },
  {
    avatar: AVTR5,
    linkedin:'https://www.linkedin.com/in/yashasvika-saxena-769604213/',
    name: "Atif Moin",
    review:
      "The guy did a fantastic job creating a new website for me.He was very friendly and nothing was too much trouble. A fantastic service, I would highly recommend and I will continue to work with him.",
  },
 
];

const Testimonials = () => {
  return (
    <section id="testimonials" data-aos="zoom-out-down">
      <h5>Review from Peers</h5>
      <h2>Testimonials</h2>
      <Swiper
        className="container testimonials_container"
        navigation
        modules={[Navigation, Pagination]}
        pagination={{ clickable: true }}
        spaceBetween={40}
        slidesPerView={1}
        
      >
        {peers.map(({ avatar, name, review ,linkedin}, index) => {
          return (
            <SwiperSlide key={index} className="testimonial">
              <div className="peer_avatar">
                <img src={avatar} alt={name} />
              </div>
              <div className="name-id">
                  <h5 className="peer_name">{name}</h5>
                  <a className="linkedin" href={linkedin} target="_blank" rel="noreferrer"><FaLinkedin /></a>
              </div>
            
              <small className="peer_review">{review}</small>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </section>
  );
};

export default Testimonials;
